export const EKOPOST = {
  TYPES: {
    POSTAL: "postal",
    KIVRA: "einbox_kivra",
  },
};
